/* global $, I18N */

import { Controller } from 'stimulus';
import pubSub from '../helpers/pubSub';

class HeaderCart extends Controller {
  static loadCart() {
    return $.ajax({
      url: '/api/cart',
    });
  }

  static renderItems(items) {
    const count = items.length;
    let itemsHTML = items.slice(0, 4).map(HeaderCart.renderItem).join('');

    if (count > 4) {
      itemsHTML += HeaderCart.renderMoreItems(count - 4);
    }

    return itemsHTML;
  }

  static renderMoreItems(count) {
    const text = count === 1 ? I18N.and_more_products : I18N.and_more_product;

    return `
      <div class="mb-2">
        ${text.replace(':num:', count)}
      </div>
    `;
  }

  static renderItem(item) {
    return `
      <div class="header-cart__item d-flex align-items-center mb-3">
        <div class="header-cart__item-thumb">
          <div class="border-basic ratio-1-1 position-relative">
            <img class="absolute-center contain" src="${item.media ? item.media : '/front_assets/img/placeholder-196x196.png'}" alt="">
          </div>
        </div>
        <div class="pl-2 flex-grow-1">
          <a href="${item.url}" class="header-cart__item-title text-uppercase">
            ${item.title}
          </a>
          <div class="d-flex">
            <span class="font-primary font-size-xs">${item.quantity}x</span>
            <span class="ml-auto color-primary">${item.price_with_tax === 'free' ? '1e GRATIS' : item.price_with_tax}</span>
          </div>
        </div>
      </div>
    `;
  }

  // eslint-disable-next-line
  connect() {
    pubSub.subscribe('cart:update', () => {
      this.refreshCart();
    });
  }

  onToggle(e) {
    const button = e.target.closest('button');
    const isOpen = button.getAttribute('aria-expanded') === 'false';

    if (!isOpen) {
      return;
    }

    this.refreshCart();
  }

  refreshCart() {
    HeaderCart.loadCart()
      .then((response) => {
        this.renderCart(response);
      });
  }

  renderCart({ meta, items }) {
    this.summaryTarget.style.display = items.length ? 'block' : 'none';

    this.itemsTarget.innerHTML = HeaderCart.renderItems(items);
    this.deliveryTarget.innerHTML = meta.shipping_with_tax;
    this.couponTarget.innerHTML = `– ${meta.coupon_value}`;
    this.totalTarget.innerHTML = meta.total_with_tax;
    this.countTarget.textContent = items.length;
  }
}

HeaderCart.targets = [
  'summary',
  'delivery',
  'coupon',
  'total',
  'items',
  'count',
];

export default HeaderCart;
